export enum WarehouseRequestTypes {
  GetSyncSettingsRequest = 'warehouse.GET_SYNC_SETTINGS_REQUEST',
  GetSyncSettingsSuccess = 'warehouse.GET_SYNC_SETTINGS_SUCCESS',
  GetSyncSettingsFailure = 'warehouse.GET_SYNC_SETTINGS_FAILURE',
  PutSyncSettingsRequest = 'warehouse.PUT_SYNC_SETTINGS_REQUEST',
  PutSyncSettingsSuccess = 'warehouse.PUT_SYNC_SETTINGS_SUCCESS',
  PutSyncSettingsFailure = 'warehouse.PUT_SYNC_SETTINGS_FAILURE',
  DeleteSyncSettingsRequest = 'warehouse.DELETE_SYNC_SETTINGS_REQUEST',
  DeleteSyncSettingsSuccess = 'warehouse.DELETE_SYNC_SETTINGS_SUCCESS',
  DeleteSyncSettingsFailure = 'warehouse.DELETE_SYNC_SETTINGS_FAILURE',

  GetRulesRequest = 'warehouse.GET_RULES_REQUEST',
  GetRulesSuccess = 'warehouse.GET_RULES_SUCCESS',
  GetRulesFailure = 'warehouse.GET_RULES_FAILURE',
  PutRulesRequest = 'warehouse.PUT_RULES_REQUEST',
  PutRulesSuccess = 'warehouse.PUT_RULES_SUCCESS',
  PutRulesFailure = 'warehouse.PUT_RULES_FAILURE',
}
